import { ArrowDownload24Regular } from "@fluentui/react-icons";
import { Button } from "@fluentui/react-components";

import styles from "./DownloadButton.module.css";

interface Props {
    className?: string;
    onClick: () => void;
}

export const DownloadButton = ({ className, onClick }: Props) => {
    return (
        <div className={`${styles.container} ${className ?? ""}`}>
            <Button icon={<ArrowDownload24Regular />} onClick={onClick}>
                {"Download log file"}
            </Button>
        </div>
    );
};
